/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export const contextDefaultProps = {
  accessToken: null,
  liveTrackingTick: null,
  liveTrackingIntervalFunc: null,
  flags: {
    showTravelTime: true,
    showClinicianDetails: false,
    showClinicianTreatments: false,
    isEditMode: false,
    showLegend: false,
    showCopy: false,
    shouldReloadClinicianTreatments: false,
    enableMultipleSelection: false,
    shouldResetCancelTreatmentInstance: false,
    showTreatmentNotesSidePanel: false,
    showConvertVisitSidePanel: false,
  },
  activeClinician: {
    id: null,
    postingId: null,
    treatments: [],
    activeTreatment: null,
    activeUnassignedTreatment: null,
  },
  availableTimeSpans: [],
  activeAssignment: null,
  assignmentForEdit: null,
  activeTreatmentInstanceForCopy: null,
  alertMessage: null,
  activeUnassignedTreatmentForCancel: null,
  activeUnassignedTreatmentForReschedule: null,
  activeNonPatientAssignment: null,
  activeNonPatientAssignmentForReschedule: null,
  activeUnassignedTreatmentForChangeUnit: null,
  multiSelectedTreatments: [],
};

const TimelineContext = React.createContext([{}, () => {}]);

const TimelineProvider = props => {
  contextDefaultProps.auth = useSelector(state => state.global.auth);
  const [state, setState] = useState({ ...contextDefaultProps });
  return <TimelineContext.Provider value={[state, setState]}>{props.children}</TimelineContext.Provider>;
};

export { TimelineContext, TimelineProvider };
